import { Geolocation } from '@capacitor/geolocation';
import { NativeGeocoder } from '@awesome-cordova-plugins/native-geocoder';

import { IGeoLocationService } from '../';
import { ST } from 'types';

class W3CGeoLocator implements IGeoLocationService {
  destroy() {}

  async getCurrentLocation(): Promise<ST.Location> {
    try {
      // ✅ Konfiguration mit längeren Timeouts und verschiedenen Accuracy-Levels
      const pos = await Geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        timeout: 15000, // 15 Sekunden statt Standard-Timeout
        maximumAge: 60000, // Cache Location für 1 Minute
      });
      
      return { 
        latitude: pos.coords.latitude, 
        longitude: pos.coords.longitude 
      };
    } catch (error) {
      console.warn('High accuracy location failed, trying with lower accuracy:', error);
      
      // ✅ Fallback mit niedriger Genauigkeit
      try {
        const pos = await Geolocation.getCurrentPosition({
          enableHighAccuracy: false,
          timeout: 10000, // 10 Sekunden für low accuracy
          maximumAge: 120000, // Cache für 2 Minuten bei low accuracy
        });
        
        return { 
          latitude: pos.coords.latitude, 
          longitude: pos.coords.longitude 
        };
      } catch (fallbackError) {
        console.error('Location request failed completely:', fallbackError);
        throw new Error(`Location unavailable: ${error instanceof Error ? error.message : String(error)}`);
      }
    }
  }

  async getAddressFromLocation(pos: ST.Location): Promise<string> {
    try {
      const result = await NativeGeocoder.reverseGeocode(
        pos.latitude!,
        pos.longitude!,
        {
          maxResults: 1,
          useLocale: true,
        }
      );
      
      if (!result.length) {
        console.warn('Geocoding returned no results');
        return 'Unbekannte Location';
      }
      
      const location = result[0];
      // ✅ Robustere Adressformatierung mit Fallbacks
      const street = location.thoroughfare || location.subThoroughfare || '';
      const city = location.locality || location.subLocality || location.administrativeArea || '';
      
      if (street && city) {
        return `${street}, ${city}`;
      } else if (city) {
        return city;
      } else if (street) {
        return street;
      } else {
        return `${pos.latitude?.toFixed(4)}, ${pos.longitude?.toFixed(4)}`;
      }
    } catch (error) {
      console.warn('Geocoding failed, using coordinates:', error);
      return `${pos.latitude?.toFixed(4)}, ${pos.longitude?.toFixed(4)}`;
    }
  }
}

export default W3CGeoLocator;
